type FileType = "DOC" | "DOCX" | "XLS" | "XLSX" | "PDF" | "PPT" | "PPTX";

export function getFileTypeColor(type: FileType | null | "org") {
  switch (type) {
    case "org":
      return "#E2E2E2";
    case "DOC":
    case "DOCX":
      return "#5297FF";
    case "XLS":
    case "XLSX":
      return "#63C172";
    case "PPT":
    case "PPTX":
      return "#F5A623";
    case "PDF":
    case null:
    default:
      return "#E45962";
  }
}
